import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RouteNames } from '@nx-ng/constants';
import { ImageUrlService } from '@nx-ng/services/image-url.service';

@Component({
  selector: 'nx-ng-page-payment-failure',
  templateUrl: './payment-failure-page.component.html',
})
export class PaymentFailurePageComponent {
  constructor(
    private router: Router,
    public imageUrlService: ImageUrlService
  ) {}

  handleCloseClicked() {
    this.router.navigate([RouteNames.TICKET_TYPES]);
  }
}
